import { useState } from "react";
import { useLocation } from "react-router-dom";
import { ProductGallery } from "../components/ProductGallery";
import FilterCategoryPrice from "../components/FilterCategoryPrice";
import { categories } from "../util";
import LoginPrompt from "../components/LoginPrompt";

export default function ProductsPage() {
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const query = new URLSearchParams(useLocation().search);
  const currentCategory = query.get("category");
  const url = currentCategory ? `Product/ProductsByCategory/${categories[currentCategory]?.id}}` : 'Product'

  return (
    <section className="flex flex-col px-8 md:px-16 py-5 md:py-10 gap-10 w-full mt-48" style={{minHeight: '70vh'}}>
      <FilterCategoryPrice />
      <h2>
        {currentCategory ? (
          <>
            Home / <span className="font-semibold capitalize">{currentCategory}</span>
          </>
        ) : (
          "All Products"
        )}
      </h2>
      <ProductGallery url={url} />

      {/* Modals */}

      <LoginPrompt openAuthModal={openAuthModal} closeAuthModal={setOpenAuthModal}/>

    </section>
  );
}
